//= require turbolinks
import {} from "jquery-ujs";
import ReactOnRails from "react-on-rails";

import BuyNowWrapper from "../bundles/orders/components/BuyNowWrapper";

ReactOnRails.register({
  BuyNowWrapper,
});
